import { SHAPES } from './constants';
import { getRandomColor, getCyberGreenColor } from './utils';
import { Shape } from './Shape';

// 色モードを外部から受け取れるようにShapeManagerを拡張
let globalColorMode = 'colorful'; // デフォルトはカラフル
export const setShapeColorMode = (mode) => {
  globalColorMode = mode;
};

export class ShapeManager {
  constructor(maxShapes, frameRate) {
    this.maxShapes = maxShapes;
    this.shapes = [];
    this.lastShapeTime = 0;
    this.minInterval = 1000 / frameRate;
    this.shapeCreationInterval = this.minInterval * 6; // 6フレーム間隔
    
    // 形状の生成確率を設定
    this.shapeCreationProbability = {
      bass: 0.2, // ベース音による形状生成の確率
      random: 0.05 // ランダムな形状生成の確率
    };
  }

  // 形状の生成条件をチェック
  shouldCreateShape(bassAverage, maxDiff) {
    const now = Date.now();
    
    // 最小間隔のチェック
    if (now - this.lastShapeTime < this.shapeCreationInterval) {
      return false;
    }

    // 音楽が再生されているかチェック
    const isPlaying = bassAverage > 0 || maxDiff > 0;
    if (!isPlaying) {
      return false;
    }

    // 音の強さによる条件
    const bassThreshold = this.maxShapes * 2;
    const diffThreshold = this.maxShapes * 2;
    
    // ベース音が強い場合
    if (bassAverage > bassThreshold && maxDiff > diffThreshold) {
      return true;
    }

    // ランダムな形状生成の確率チェック
    if (Math.random() < this.shapeCreationProbability.random) {
      return true;
    }

    return false;
  }

  // 新しい形状を作成
  createShape(intensity, canvasWidth, canvasHeight) {
    // 最大数に達している場合は古い形状を削除
    if (this.shapes.length >= this.maxShapes) {
      const oldestShape = this.shapes.shift();
      if (oldestShape) {
        oldestShape.alpha = 0; // フェードアウト
      }
    }

    // 形状のパラメータを設定
    const x = Math.random() * canvasWidth;
    const y = Math.random() * canvasHeight;
    
    // 音の強さに応じたベースサイズを設定
    let baseSize = 10; // 最小サイズ
    if (intensity > 100) {
      baseSize = 50; // 音が大きい時
    } else if (intensity > 60) {
      baseSize = 30;
    }
    const intensitySize = Math.max(baseSize, intensity / 4.0);
    
    // ランダムな変動を追加（±20%）
    const randomFactor = 1 + (Math.random() - 0.5) * 0.4; // -20%から+20%の範囲
    const size = Math.round(intensitySize * randomFactor);

    // 色をモードごとに分岐
    let color;
    if (globalColorMode === 'cyber-green') {
      color = getCyberGreenColor();
    } else {
      color = getRandomColor();
    }
    const type = Object.values(SHAPES)[Math.floor(Math.random() * Object.values(SHAPES).length)];
    
    const shape = new Shape(x, y, size, color, type);
    shape.trailMaxLength = 12;
    shape.trailUpdateInterval = 2;
    this.shapes.push(shape);
    this.lastShapeTime = Date.now();

    return shape;
  }

  // 形状の更新
  updateShapes() {
    this.shapes.forEach((shape, index) => {
      if (!shape.update()) {
        this.shapes.splice(index, 1);
      }
    });
  }

  // 形状の描画
  drawShapes(ctx) {
    this.shapes.forEach(shape => {
      shape.draw(ctx);
    });
  }

  // 形状の数を取得
  getShapeCount() {
    return this.shapes.length;
  }

  // 全ての形状をクリア
  clearShapes() {
    this.shapes = [];
  }
}
